import { Col, Row } from "antd";
import { useRouter } from "next/router";
import { Dispatch, FC, SetStateAction } from "react";
import { routes } from "../../../../config/route-config";
import { handlePlateNumberDisplay } from "../../../../helpers/plateNumberHandler";
import { SingleAlert } from "../../../../lib/types/settings";
import { dateDisplay } from "../../../../utils/dateFormatter";
import { G_Button } from "../../Button";
import { G_Text } from "../../Text";

interface Props {
  setIsNotificationOpen: Dispatch<SetStateAction<boolean>>;
  alert: SingleAlert;
}

/**
 * @since December 2023
 * @author Issa Jean Marie <jeanmarieissa@gmail.com>
 * @see {@link https://issadevs.com} - Author's website
 * @returns {JSX.Element}
 */

const SingleNotificationItem: FC<Props> = ({
  alert,
  setIsNotificationOpen
}): JSX.Element => {
  const router = useRouter();

  const handleTakeALook = () => {
    setIsNotificationOpen(false);
    router.push({
      pathname: `${routes.Fleet.url}/${alert?.truck?.id}`,
      query: {
        ...router.query,
        alert_id: alert?.id,
        truck_health_active_tab: 2,
        active_tab: alert.type === "SHIFT_VIOLATION" ? "violations" : "",
        truck_active_tab: alert.type === "TRUCK_REPAIR_EXPIRATION" ? 1 : "",
        active_truck: alert?.truck?.id
      }
    });
  };

  const isPending = alert?.status === "PENDING";

  return (
    <Row
      justify="space-between"
      align="top"
      gutter={24}
      className="p-8 py-4"
      wrap={false}
    >
      <Col flex="none">
        <G_Button
          bg="ox_2_greyish_white"
          isDynamic
          iconSrc="/icons/ic-ecommerce-delivery-black.svg"
          size="large"
        />
      </Col>

      <Col flex="auto" className="border-b pb-8">
        <Row justify="space-between" align="top">
          <Col>
            <G_Text weight="bold" dimension="caption">
              {handlePlateNumberDisplay(alert?.truck?.plateNumber)} -{" "}
              {alert?.title}
            </G_Text>
            <G_Text dimension="caption" className="opacity-40" mb={12}>
              {alert?.message}
            </G_Text>

            <G_Button
              type={isPending ? "primary" : "default"}
              bg={isPending ? "ox_2_faded_primary" : "ox_2_white"}
              size="middle"
              weight="bold"
              faded={isPending}
              isDynamic
              uppercase
              pointer
              onClick={handleTakeALook}
            >
              <G_Text
                weight="bold"
                dimension="small"
                color={isPending ? "ox_2_primary" : "ox_2_black"}
                pointer
              >
                TAKE A LOOK
              </G_Text>
            </G_Button>
          </Col>

          <Col>
            <G_Text dimension="caption" italic className="opacity-40">
              {dateDisplay(alert?.createdAt)}
            </G_Text>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default SingleNotificationItem;
